"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var signedHeaderFactory_1 = __importDefault(require("./signedHeaderFactory"));
var utils_1 = require("./utils");
function signedFetchFactory(options) {
    if (options === void 0) { options = {}; }
    var signedHeader = (0, signedHeaderFactory_1.default)(options);
    var URL = (0, utils_1.getImplementation)(options, "URL");
    var Request = (0, utils_1.getImplementation)(options, "Request");
    var fetch = (0, utils_1.getImplementation)(options, "fetch");
    return function signedFetch(input, init) {
        if (init && init.identity) {
            var identity = init.identity, metadata = init.metadata, originalInit = __rest(init, ["identity", "metadata"]);
            // handle url as string
            if (typeof input === "string" ||
                input instanceof URL ||
                (globalThis.URL && input instanceof globalThis.URL)) {
                var url_1 = typeof input === "string" ? new URL(input) : input;
                var request_1 = new Request(url_1.toString(), __assign(__assign({}, originalInit), { headers: signedHeader(identity, init.method || "GET", url_1.pathname, metadata || {}, originalInit === null || originalInit === void 0 ? void 0 : originalInit.headers) }));
                return fetch(request_1);
            }
            var url = new URL(input.url);
            var request_2 = new Request(input);
            var headers = signedHeader(identity, input.method || "GET", url.pathname, metadata || {});
            headers.forEach(function (value, key) {
                request_2.headers.set(key, value);
            });
            return fetch(request_2);
        }
        return fetch(input, init);
    };
}
exports.default = signedFetchFactory;
//# sourceMappingURL=signedFetchFactory.js.map